import { render, staticRenderFns } from "./general-translations-tab.vue?vue&type=template&id=a60a8ed4"
import script from "./general-translations-tab.vue?vue&type=script&lang=js"
export * from "./general-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports